import { EventEmitter } from "events";
import dispatcher from "../dispatcher";
import { paymentModeConstant } from "../constants/constants";
class PaymentModeStore extends EventEmitter {
    constructor() {
        super();
        this.payModes = [];
    }
    getAll() {
        return this.payModes;
    }

    handleAction(action) {
        switch (action.type) {
            case paymentModeConstant.PAYMENTMODE_CREATED: {
                //console.log(this);
                const { payMode } = action;
                this.payModes.push(payMode);
                this.emit(paymentModeConstant.PAYMENTMODE_CREATED, `Payment Mode ${payMode.payModeName} created successfully.`);
                this.emit(paymentModeConstant.PAYMENTMODE_STORE_CHANGE);
                break;
            }
            case paymentModeConstant.PAYMENTMODE_CREATION_FAILED: {
                this.emit(paymentModeConstant.PAYMENTMODE_CREATION_FAILED, action.msg);
                break;
            }
            case paymentModeConstant.FETCHED_ALL_PAYMENTMODE: {
                //console.log("inside payment store fetch all", action.data);
                this.payModes = action.data;
                this.emit(paymentModeConstant.PAYMENTMODE_STORE_CHANGE);
                break;
            }
            case paymentModeConstant.PAYMENTMODE_FETCH_FAILED: {
                this.emit(paymentModeConstant.PAYMENTMODE_FETCH_FAILED, action.msg);
                break;
            }
            default:
                break;
        }
    }
}

const paymentModeStore = new PaymentModeStore();
dispatcher.register(paymentModeStore.handleAction.bind(paymentModeStore));
export default paymentModeStore;


// WEBPACK FOOTER //
// ./src/jsx/store/payment-mode-store.jsx